export type Locale = 'zh' | 'en';

type Params = Record<string, string | number>;

const translations: Record<Locale, Record<string, string>> = {
  zh: {
    'app.documentTitle': 'Siege Tank · 钢铁防线',
    'app.kicker': 'Siege Tank',
    'app.brand': '钢铁防线',
    'app.subtitle': '双人协作，守住基地，清空战场。',
    'app.canvasLabel': '钢铁防线游戏画布',
    'app.immersive': '沉浸模式',
    'hud.level': '关卡',
    'hud.score': '得分',
    'hud.enemies': '敌军',
    'hud.base': '基地',
    'hud.idle': '休整',
    'hud.hp': '生命 {value}',
    'hud.wave': '下一波',
    'hud.waveClear': '清空',
    'section.basic': '基础',
    'section.ranked': '排位配置',
    'section.customBasic': '自定义基础',
    'section.input': '玩家输入',
    'section.rules': '玩法规则',
    'section.progression': '成长与道具',
    'menu.modeList': '游戏模式',
    'menu.ruleset': '战斗类型',
    'menu.rulesetHint': '选择排位模式或自定义模式',
    'menu.ruleset.ranked': '排位模式',
    'menu.ruleset.custom': '自定义模式',
    'menu.playerCount': '玩家人数',
    'menu.playerCountHint': '自定义模式支持 1-4 人本地协作',
    'menu.playerCount.one': '1 人',
    'menu.playerCount.two': '2 人',
    'menu.playerCount.three': '3 人',
    'menu.playerCount.four': '4 人',
    'menu.p1TankClass': 'P1 车种',
    'menu.p2TankClass': 'P2 车种',
    'menu.p3TankClass': 'P3 车种',
    'menu.p4TankClass': 'P4 车种',
    'menu.tankClassHint': '仅自定义模式生效，排位固定标准型',
    'menu.tankClass.standard': '标准型',
    'menu.tankClass.assault': '突击型',
    'menu.tankClass.heavy': '重装型',
    'menu.locale': '界面语言',
    'menu.localeHint': '切换所有界面文字',
    'guide.open': '玩法指南',
    'guide.openHint': '坦克、敌军、Boss 和基础打法',
    'guide.openCta': '查看',
    'guide.close': '关闭玩法指南',
    'guide.kicker': 'Field Manual',
    'guide.title': '玩法指南',
    'guide.subtitle': '守住基地，利用装甲角度和弹药特性，把敌军分批清掉。',
    'guide.heroAlt': '钢铁防线宣传画',
    'guide.section.setup': '开始前设置',
    'guide.setup.touchTitle': '手机和平板',
    'guide.setup.touchBody': '先在玩家输入里把对应玩家改成触屏，再选择摇杆或 D-pad；建议横屏并开启全屏。',
    'guide.setup.keyboardTitle': '键盘',
    'guide.setup.keyboardBody': '玩家可选择 WASD、方向键或其他键位组；只有键盘模式需要自定义开火键。',
    'guide.setup.gamepadTitle': '手柄',
    'guide.setup.gamepadBody': '连接后为玩家选择对应手柄编号；多人游玩时每个玩家都可以独立选择键盘或手柄。',
    'guide.setup.rankedTitle': '排位榜单',
    'guide.setup.rankedBody': '排位模式会固定规则并提交成绩；自定义模式适合练习、触屏调试和多人娱乐。',
    'guide.section.basics': '基础目标',
    'guide.basic.baseTitle': '保护基地',
    'guide.basic.baseBody': '基地被毁会失败。无敌基地只在自定义模式下放松练习，排位默认基地可被摧毁。',
    'guide.basic.clearTitle': '清空战场',
    'guide.basic.clearBody': '每关敌军清空后会进入短暂休整，抓紧补给、调整站位，再进下一关。',
    'guide.basic.armorTitle': '正面装甲',
    'guide.basic.armorBody': '玩家坦克正面更硬，吃炮时尽量用车头接弹；打 Boss 时多绕侧面和背面。',
    'guide.basic.rankedTitle': '排位与自定义',
    'guide.basic.rankedBody': '排位规则固定并上传成绩；自定义适合多人、手柄、触屏和各种练习设置。',
    'guide.section.players': '我方坦克',
    'guide.player.standardTitle': '标准型',
    'guide.player.standardBody': '攻防均衡，Lv.3 后会周期性打出穿甲弹。适合排位和稳健推进。',
    'guide.player.standardTip': '打法：利用正面装甲卡角度，别急着和 Boss 正面对炮。',
    'guide.player.assaultTitle': '突击型',
    'guide.player.assaultBody': '速度和射击节奏更好，Lv.3 后获得速射曳光弹，可压制敌人行动。',
    'guide.player.assaultTip': '打法：多横移、多绕侧，别长时间停在敌军炮线里。',
    'guide.player.heavyTitle': '重装型',
    'guide.player.heavyBody': '血量和装甲更扎实，移动较慢，Lv.3 后获得爆破弹，能波及轻型目标和墙体。',
    'guide.player.heavyTip': '打法：守通道、拆障碍、保护基地，避免被灵活敌人绕后。',
    'guide.section.enemies': '敌军单位',
    'guide.enemy.scoutTitle': '侦察坦克',
    'guide.enemy.scoutBody': '红色轻型单位，血薄、速度快，近距离会尝试开火。',
    'guide.enemy.scoutTip': '提示：优先清掉绕后的侦察坦克，别让它们偷基地。',
    'guide.enemy.assaultTitle': '突击坦克',
    'guide.enemy.assaultBody': '黄色单位，火力和弹速比侦察型更强，喜欢正面施压。',
    'guide.enemy.assaultTip': '提示：别在开阔地硬换，诱导它撞墙后再打。',
    'guide.enemy.heavyTitle': '黑色重型坦克',
    'guide.enemy.heavyBody': '移动慢、血量高，炮弹威力更大但飞行更慢。',
    'guide.enemy.heavyTip': '提示：拉开距离，等它开炮后再反击。',
    'guide.enemy.sniperTitle': '狙击坦克',
    'guide.enemy.sniperBody': '血薄但瞄准欲望强，炮弹速度快，喜欢隔线点射。',
    'guide.enemy.sniperTip': '提示：不要沿同一条线直追，先横移错开炮线再接近。',
    'guide.section.bosses': 'Boss 特点',
    'guide.boss.siegeTitle': '攻城型',
    'guide.boss.siegeBody': '标准 Boss，正面装甲很厚，点位压迫稳定。',
    'guide.boss.hunterTitle': '猎袭型',
    'guide.boss.hunterBody': '机动和正面火力更强，但正面防护低于堡垒型。',
    'guide.boss.bulwarkTitle': '堡垒型',
    'guide.boss.bulwarkBody': '最硬、最慢、炮弹最重，硬拼代价很高。',
    'guide.boss.sniperTitle': '狙击型',
    'guide.boss.sniperBody': '护甲薄，移动快，会拉距离和突然回头开火。',
    'guide.section.tactics': '实战提示',
    'guide.tip.one': '先守基地入口，再逐步推线，不要被敌人从两侧穿过去。',
    'guide.tip.two': '砖墙可以多炮摧毁，钢墙需要穿甲弹或特殊弹药处理。',
    'guide.tip.three': '护盾只免伤，不会让敌方炮弹穿过你的坦克，可以用来替队友挡线。',
    'guide.tip.four': 'Boss 战不要贪炮，等它转向、开炮或撞墙后再打侧后方。',
    'menu.levelDelay': '过关休整',
    'menu.levelDelayHint': '清场后拾取道具的等待时间',
    'menu.seconds.2': '2 秒',
    'menu.seconds.3': '3 秒',
    'menu.seconds.4': '4 秒',
    'menu.seconds.5': '5 秒',
    'menu.seconds.6': '6 秒',
    'menu.seconds.7': '7 秒',
    'menu.seconds.8': '8 秒',
    'menu.seconds.9': '9 秒',
    'menu.seconds.10': '10 秒',
    'menu.obstacleDensity': '障碍密度',
    'menu.obstacleDensityHint': '控制砖墙、钢墙和地形阻隔数量',
    'menu.obstacleDensity.low': '较低',
    'menu.obstacleDensity.normal': '标准',
    'menu.obstacleDensity.high': '较高',
    'menu.obstacleDensity.dense': '密集',
    'menu.enemyAi': '敌军 AI',
    'menu.enemyAiHint': '默认保留经典复古行为',
    'menu.enemyAi.classic': '经典',
    'menu.enemyAi.enhanced': '强化',
    'menu.p1Control': 'P1 操作',
    'menu.p2Control': 'P2 操作',
    'menu.p3Control': 'P3 操作',
    'menu.p4Control': 'P4 操作',
    'menu.controlHint': '键盘、手柄或触屏控制',
    'menu.controlHintKeyboard': '使用键盘移动与键盘开火键',
    'menu.controlHintGamepad': '支持多手柄；同选时按 P1-P4 顺序分配',
    'menu.controlHintTouch': '使用触屏移动区与屏幕开火按钮',
    'menu.controlHintInactive': '当前玩家未启用，输入配置暂不启用',
    'menu.localMultiplayerNote': 'P1-P4 都可选择键盘或手柄；多个键盘玩家会自动错开移动布局和冲突开火键。',
    'menu.control.keyboard': '键盘',
    'menu.control.gamepad': '手柄',
    'menu.control.touchDpad': '触屏 D-pad',
    'menu.control.touchStick': '触屏摇杆',
    'menu.keyboardMove': '键盘移动',
    'menu.keyboardMoveHint': '选择当前玩家的键盘移动方案',
    'menu.keyboardMoveHintArrows': '当前使用方向键移动',
    'menu.keyboardMoveHintWasd': '当前使用 WASD 移动',
    'menu.keyboardMoveHintTfgh': '当前使用 TFGH 移动',
    'menu.keyboardMoveHintIjkl': '当前使用 IJKL 移动',
    'menu.keyboardMoveHintNumpad': '当前使用数字小键盘移动',
    'menu.keyboardMoveHintInactive': '当前玩家未启用，无法设置键盘移动',
    'menu.moveScheme.arrows': '方向键',
    'menu.moveScheme.wasd': 'WASD',
    'menu.moveScheme.tfgh': 'TFGH',
    'menu.moveScheme.ijkl': 'IJKL',
    'menu.moveScheme.numpad': '数字键盘',
    'menu.gamepadSlot': '手柄选择',
    'menu.gamepadSlotHint': '指定当前玩家使用哪个手柄',
    'menu.playerInactive': '未启用',
    'menu.p1Fire': 'P1 开火',
    'menu.p2Fire': 'P2 开火',
    'menu.p3Fire': 'P3 开火',
    'menu.p4Fire': 'P4 开火',
    'menu.fireBindHint': '键盘模式下点击后按键绑定',
    'menu.fireBindHintGamepad': '手柄模式固定使用 A / RT 开火',
    'menu.fireBindHintTouch': '触屏模式固定使用屏幕开火按钮',
    'menu.fireBindHintInactive': '当前玩家未启用，无法设置开火键',
    'menu.infiniteLives': '无限生命',
    'menu.infiniteLivesHint': '阵亡后持续重生',
    'menu.invincibleBase': '无敌基地',
    'menu.invincibleBaseHint': '基地永久护盾',
    'menu.friendlyFire': '友军伤害',
    'menu.friendlyFireHint': '合作时更紧张',
    'menu.upgradeRate': '升级掉落',
    'menu.upgradeRateHint': '控制坦克升级道具出现率',
    'menu.upgradeRate.off': '关闭',
    'menu.upgradeRate.low': '较低',
    'menu.upgradeRate.normal': '标准',
    'menu.upgradeRate.high': '较高',
    'menu.loseUpgrade': '阵亡掉级',
    'menu.loseUpgradeHint': '死亡后升级等级下降一级',
    'menu.initialLevel': '初始等级',
    'menu.initialLevelHint': '我方坦克开局和接关时的等级',
    'action.start': '开始作战',
    'action.redeploy': '重新部署',
    'action.resume': '继续',
    'action.restart': '重开',
    'action.apply': '套用设置',
    'action.menu': '主菜单',
    'action.continue': '接关',
    'action.abandon': '放弃',
    'action.fullscreen': '全屏',
    'action.exitFullscreen': '退出全屏',
    'action.audio': '音频',
    'action.previewExplosion': '试听爆炸音效',
    'action.previewExplosionText': '爆',
    'control.fireVerb': '开火',
    'control.system': '系统',
    'control.systemHelp': 'Esc 暂停 · R 重开',
    'control.source.keyboardArrows': '方向键移动',
    'control.source.keyboardWasd': 'WASD 移动',
    'control.source.keyboardTfgh': 'TFGH 移动',
    'control.source.keyboardIjkl': 'IJKL 移动',
    'control.source.keyboardNumpad': '数字键盘移动',
    'control.source.gamepad': '手柄移动',
    'control.gamepad.auto': '自动手柄',
    'control.gamepad.autoOne': '自动：1号手柄',
    'control.gamepad.autoTwo': '自动：2号手柄',
    'control.gamepad.autoThree': '自动：3号手柄',
    'control.gamepad.autoFour': '自动：4号手柄',
    'control.gamepad.one': '1 号手柄',
    'control.gamepad.two': '2 号手柄',
    'control.gamepad.three': '3 号手柄',
    'control.gamepad.four': '4 号手柄',
    'control.source.touchDpad': '触屏 D-pad',
    'control.source.touchStick': '触屏摇杆',
    'control.fire.touch': '按钮',
    'control.keyPrompt': '按键...',
    'control.key.space': '空格',
    'ranked.preset': '排位预设',
    'ranked.presetHint': '固定规则，会计入独立排行榜',
    'ranked.preset.standardSolo': '标准单人',
    'ranked.preset.standardDuo': '标准双人',
    'ranked.preset.hardcoreSolo': '高难单人',
    'ranked.preset.hardcoreDuo': '高难双人',
    'ranked.variant.standardHint': '固定经典规则，稳稳地拼分数。',
    'ranked.variant.hardcoreHint': '更硬、更紧、更危险的高难排位。',
    'ranked.summary.title': '当前排位',
    'ranked.summary.note': '使用接关或开发者菜单后，本局不会计入排行榜。',
    'ranked.summary.board': '排行榜',
    'ranked.summary.players': '玩家人数',
    'ranked.summary.rules': '生命与基地',
    'ranked.summary.progression': '成长与友伤',
    'ranked.summary.battlefield': '战场与敌军',
    'ranked.summary.rulesValue': '有限生命 · 基地可摧毁',
    'ranked.summary.progression.standard': '升级掉落标准 · 不掉级 · 无友伤',
    'ranked.summary.progression.hardcore': '升级掉落较低 · 阵亡掉级 · 友伤开启',
    'ranked.summary.battlefield.standard': '5 秒休整 · 较高障碍 · 经典 AI',
    'ranked.summary.battlefield.hardcore': '5 秒休整 · 密集障碍 · 强化 AI',
    'ranked.summary.ranked': '计入排行榜',
    'leaderboard.title': '排位积分榜',
    'leaderboard.kicker': '排位榜单',
    'leaderboard.close': '关闭排行榜',
    'leaderboard.open': '查看排行榜',
    'leaderboard.editProfile': '改昵称',
    'leaderboard.identityLabel': '排位身份',
    'leaderboard.identityKicker': '排位身份',
    'leaderboard.profileTitle': '冲榜身份',
    'leaderboard.profileHint': '开始排位前先确认昵称和目标榜单。',
    'leaderboard.refresh': '刷新榜单',
    'leaderboard.nickname': '排行榜昵称',
    'leaderboard.nicknameHint': '排位模式提交成绩时使用这个名字',
    'leaderboard.tabs': '排行榜模式',
    'leaderboard.tabStandardSolo': '标准单人',
    'leaderboard.tabStandardDuo': '标准双人',
    'leaderboard.tabHardcoreSolo': '高难单人',
    'leaderboard.tabHardcoreDuo': '高难双人',
    'leaderboard.loading': '正在读取排行榜…',
    'leaderboard.empty': '还没有上榜成绩，来打第一把吧。',
    'leaderboard.unavailable': '排行榜暂时不可用，等后端绑定好数据库后就会恢复。',
    'leaderboard.note': '仅排位模式成绩可上传。标准/高难、单人/双人分开统计。',
    'leaderboard.rank': '第 {rank} 名',
    'leaderboard.scoreLine': '分数 {score} · 关卡 {stage}',
    'leaderboard.durationLine': '用时 {minutes}:{seconds}',
    'leaderboard.statusTitle': '最近排位成绩',
    'leaderboard.statusRanked': '{mode} · {score} 分 · 第 {rank} 名',
    'leaderboard.statusBest': '当前个人最佳 {bestScore} 分 · 关卡 {bestStage}',
    'leaderboard.statusBestImproved': '新的个人最佳，继续保持。',
    'leaderboard.celebrationKicker': '排位突破',
    'leaderboard.celebrationSummary': '{mode} · {score} 分 · 第 {rank} 名',
    'leaderboard.statusMilestone.top10': '首次冲进前 10',
    'leaderboard.statusMilestone.top3': '首次冲进前 3',
    'leaderboard.statusMilestone.champion': '首次登顶第 1 名',
    'leaderboard.statusMilestone.personalBest': '个人最佳',
    'leaderboard.meTitle': '我在当前榜',
    'leaderboard.meEmpty': '这个榜还没有你的成绩，去打一次试试。',
    'leaderboard.meRanked': '{nickname} · 第 {rank} 名 · {score} 分',
    'leaderboard.meBest': '个人最佳关卡 {stage} · 用时 {minutes}:{seconds}',
    'leaderboard.meBadge': '你',
    'leaderboard.identityBoardActive': '当前排位：{mode}',
    'leaderboard.identityBoardCustom': '查看榜单：{mode}',
    'leaderboard.identityLoadingTitle': '正在读取当前名次',
    'leaderboard.identityLoadingDetail': '排行榜连接中，请稍等。',
    'leaderboard.identityUnavailableTitle': '排行榜暂不可用',
    'leaderboard.identityUnavailableDetail': '本地仍可游玩，网络恢复后再刷新榜单。',
    'leaderboard.identityEmptyTitle': '还没有当前榜成绩',
    'leaderboard.identityEmptyDetail': '设置昵称，选择排位，打出第一把。',
    'leaderboard.identityRankedTitle': '第 {rank} 名 · {score} 分',
    'leaderboard.identityRankedDetail': '{mode} · 关卡 {stage} · 用时 {minutes}:{seconds}',
    'leaderboard.practiceMode': '当前排位成绩已锁定，继续后将进入练习局，不再刷新本次排行。',
    'leaderboard.eligibilityUnknown': '当前配置尚未检测',
    'leaderboard.eligiblePreset': '当前配置会计入 {mode}',
    'leaderboard.ineligible': '当前配置是自定义模式，不计入排行榜',
    'leaderboard.submitSuccess': '排行榜已上传 · {mode}',
    'leaderboard.submitSuccessDetailed': '{mode} 已记录 · {score} 分 · 第 {rank} 名',
    'leaderboard.submitSkipped': '本局未计入排行榜',
    'leaderboard.submitFailed': '排行榜提交失败，稍后可再试',
    'touch.controls': '触屏控制',
    'touch.stick': '移动摇杆',
    'touch.dpad': '移动方向键',
    'touch.mode': '触控模式',
    'touch.mode.stick': '摇杆',
    'touch.lockLayout': '锁定位置',
    'touch.unlockLayout': '解锁位置',
    'touch.fire': '开火',
    'touch.pause': '暂停',
    'touch.rotate': '请横屏游玩',
    'touch.up': '向上',
    'touch.down': '向下',
    'touch.left': '向左',
    'touch.right': '向右',
    'confirm.restartLevel': '确定重开本关吗？当前关卡进度会丢失。',
    'confirm.applySettings': '确定套用设置并重新开局吗？当前作战进度会丢失。',
    'confirm.returnMenu': '确定返回主菜单吗？当前作战进度会丢失。',
    'confirm.abandonContinue': '确定放弃接关并返回主菜单吗？当前作战会结束。',
    'overlay.pause.title': '暂停',
    'overlay.pause.subtitle': '可以继续、重开，或调整模式后重新部署。',
    'overlay.continue.title': '继续作战？',
    'overlay.continue.subtitle': '{reason}，剩余 {count} 次接关。接关后回满生命，坦克升级清零，并从当前关继续。',
    'overlay.continue.rankedRecorded': '{reason}，剩余 {count} 次接关。当前成绩 {score} 分已记录到 {mode}，暂列第 {rank} 名。若继续接关，后续只作练习，不再刷新本局排位。',
    'overlay.gameOver.title': '任务失败',
    'overlay.gameOver.subtitle': '{reason}，接关次数已用尽。',
    'status.paused': '暂停',
    'status.nextLevel': '下一关 {seconds}',
    'settlement.kicker': '区域清空',
    'settlement.title': '第 {level} 关完成',
    'settlement.bonus': '清场奖励 +{bonus}',
    'settlement.collect': '拾取补给，准备下一关',
    'settlement.next': '{seconds} 秒后进入第 {level} 关',
    'message.paused': '暂停',
    'message.resume': '继续作战',
    'message.level': '第 {level} 关',
    'message.baseDamaged': '基地受损 {hp}/3',
    'message.respawn': 'P{player} 重生',
    'message.bossIncoming': '{variant} Boss 来袭',
    'message.continue': '接关继续 · 剩余 {count}',
    'message.levelComplete': '关卡完成',
    'enemy.short.light': '侦察',
    'enemy.short.assault': '突击',
    'enemy.short.heavy': '重装',
    'enemy.short.sniper': '狙击',
    'enemy.short.boss': 'Boss',
    'bossVariant.siege': '攻城型',
    'bossVariant.hunter': '猎袭型',
    'bossVariant.bulwark': '堡垒型',
    'bossVariant.sniper': '狙击型',
    'bossVariant.preview.siege': '攻城',
    'bossVariant.preview.hunter': '猎袭',
    'bossVariant.preview.bulwark': '堡垒',
    'bossVariant.preview.sniper': '狙击',
    'dev.title': '开发者菜单',
    'dev.section': '开发者菜单',
    'dev.level': '跳转关卡',
    'dev.levelHint': '直接开始指定关卡，保留当前模式设置',
    'dev.jump': '跳转',
    'dev.powerup': '生成道具',
    'dev.powerupHint': '在我方坦克附近刷出测试道具',
    'dev.enemy': '生成敌军',
    'dev.enemyHint': '手动刷出指定敌人，方便测血量和行为',
    'dev.bossVariant': 'Boss 型号',
    'dev.bossVariantHint': '单独选择要手动召唤的 Boss 变体',
    'dev.speed': '慢速模式',
    'dev.speedHint': '降低整体时间流速，方便观察前摇和碰撞',
    'dev.aiOverlay': 'AI 调试信息',
    'dev.aiOverlayHint': '在敌军头顶显示当前目标、状态和移动方向',
    'dev.playerInvincible': '玩家临时无敌',
    'dev.playerInvincibleHint': '只用于测试，不影响正式规则配置',
    'dev.baseInvincible': '基地临时无敌',
    'dev.baseInvincibleHint': '方便反复测试 Boss、刷怪和基地告警',
    'dev.audioState': '音频状态',
    'dev.audioStateHint': '用于排查 iPhone / iPad 浏览器里声音是否被挂起',
    'dev.audioWake': '唤醒音频',
    'dev.audio.running': '运行中',
    'dev.audio.suspended': '已挂起',
    'dev.audio.interrupted': '被打断',
    'dev.audio.closed': '已关闭',
    'dev.audio.unavailable': '未创建',
    'dev.spawn': '生成',
    'dev.collapse': '收起',
    'dev.expand': '展开',
    'dev.spawnEnemy': '召唤',
    'dev.step': '推进 1 帧',
    'dev.healPlayers': '补满血量',
    'dev.maxUpgrade': '升到 Lv.4',
    'dev.clearEnemies': '清空敌军',
    'dev.spawnBoss': '召唤 Boss',
    'dev.damageBase': '制造基地受损',
    'dev.hint': '仅用于测试。按 F12 再次隐藏；若浏览器拦截，可试试 Shift + `。',
    'dev.toast.jump': '开发跳转 · 第 {level} 关',
    'dev.toast.healed': '开发补给 · 我方满血',
    'dev.toast.upgrade': '开发强化 · 全员 Lv.{level}',
    'dev.toast.powerup': '开发刷出 · {powerup}',
    'dev.toast.speed': '开发时间倍率 · {scale}×',
    'dev.toast.clear': '开发清场 · 消灭 {count} 个敌军',
    'dev.toast.playerInvincibleOn': '开发开关 · 玩家临时无敌已开启',
    'dev.toast.playerInvincibleOff': '开发开关 · 玩家临时无敌已关闭',
    'dev.toast.baseInvincibleOn': '开发开关 · 基地临时无敌已开启',
    'dev.toast.baseInvincibleOff': '开发开关 · 基地临时无敌已关闭',
    'dev.toast.baseDamaged': '开发状态 · 基地已调整为受损',
    'dev.toast.spawnEnemy': '开发召唤 · {enemy}',
    'dev.toast.spawnBlocked': '开发召唤失败 · 出生点被占用',
    'dev.enemy.boss': 'Boss',
    'dev.enemy.heavy': '黑色重型坦克',
    'dev.enemy.sniper': '狙击坦克',
    'dev.enemy.assault': '突击坦克',
    'dev.enemy.light': '轻型坦克',
    'powerup.rapid': '射速提升',
    'powerup.shield': '护盾上线',
    'powerup.bomb': '清屏轰炸',
    'powerup.life': '生命补给',
    'powerup.freeze': '冻结敌军',
    'powerup.repair': '修复基地',
    'powerup.baseShield': '基地护盾',
    'powerup.jam': '电磁干扰',
    'powerup.upgrade': '坦克升级',
    'powerup.heal': '满血维修',
    'message.powerupPickup': '{powerup} P{player}',
    'gameOver.baseDestroyed': '基地被摧毁',
    'gameOver.outOfLives': '生命耗尽',
    'base.invincible': '无敌',
    'base.shielded': '护盾',
    'base.destroyed': '摧毁',
    'base.stable': '稳定',
  },
  en: {
    'app.documentTitle': 'Siege Tank',
    'app.kicker': 'Siege Tank',
    'app.brand': 'Siege Tank',
    'app.subtitle': 'Fight together, protect the base, clear the field.',
    'app.canvasLabel': 'Siege Tank battlefield',
    'app.immersive': 'Immersive mode',
    'hud.level': 'Level',
    'hud.score': 'Score',
    'hud.enemies': 'Enemies',
    'hud.base': 'Base',
    'hud.idle': 'Idle',
    'hud.hp': 'HP {value}',
    'hud.wave': 'Next',
    'hud.waveClear': 'Clear',
    'section.basic': 'Basics',
    'section.ranked': 'Ranked Setup',
    'section.customBasic': 'Custom Basics',
    'section.input': 'Player Input',
    'section.rules': 'Rules',
    'section.progression': 'Progression',
    'menu.modeList': 'Game modes',
    'menu.ruleset': 'Battle Type',
    'menu.rulesetHint': 'Choose ranked or custom rules',
    'menu.ruleset.ranked': 'Ranked',
    'menu.ruleset.custom': 'Custom',
    'menu.playerCount': 'Players',
    'menu.playerCountHint': 'Custom mode supports 1-4 local players',
    'menu.playerCount.one': '1 Player',
    'menu.playerCount.two': '2 Players',
    'menu.playerCount.three': '3 Players',
    'menu.playerCount.four': '4 Players',
    'menu.p1TankClass': 'P1 Tank Type',
    'menu.p2TankClass': 'P2 Tank Type',
    'menu.p3TankClass': 'P3 Tank Type',
    'menu.p4TankClass': 'P4 Tank Type',
    'menu.tankClassHint': 'Custom mode only; ranked uses standard tanks',
    'menu.tankClass.standard': 'Standard',
    'menu.tankClass.assault': 'Assault',
    'menu.tankClass.heavy': 'Heavy',
    'menu.locale': 'Language',
    'menu.localeHint': 'Switch all interface text',
    'guide.open': 'How to Play',
    'guide.openHint': 'Tanks, enemies, Bosses, and field tactics',
    'guide.openCta': 'Open',
    'guide.close': 'Close guide',
    'guide.kicker': 'Field Manual',
    'guide.title': 'How to Play',
    'guide.subtitle': 'Protect the base, use armor angles and special shells, and clear enemies in controlled waves.',
    'guide.heroAlt': 'Siege Tank promotional artwork',
    'guide.section.setup': 'Setup First',
    'guide.setup.touchTitle': 'Phone & Tablet',
    'guide.setup.touchBody': 'In Player Input, set the player to Touch, then choose joystick or D-pad. Landscape and fullscreen are recommended.',
    'guide.setup.keyboardTitle': 'Keyboard',
    'guide.setup.keyboardBody': 'Players can choose WASD, arrow keys, or other key groups. Fire-key binding only matters in keyboard mode.',
    'guide.setup.gamepadTitle': 'Gamepad',
    'guide.setup.gamepadBody': 'After connecting pads, choose the matching gamepad number for each player. Every player can choose keyboard or gamepad independently.',
    'guide.setup.rankedTitle': 'Ranked Boards',
    'guide.setup.rankedBody': 'Ranked mode locks the rules and submits scores. Custom mode is for practice, touch tuning, and local multiplayer.',
    'guide.section.basics': 'Core Goals',
    'guide.basic.baseTitle': 'Protect the base',
    'guide.basic.baseBody': 'The run fails if the base is destroyed. Invincible Base is a custom-mode training aid; ranked keeps the base vulnerable.',
    'guide.basic.clearTitle': 'Clear the field',
    'guide.basic.clearBody': 'After every wave is cleared, you get a short break to grab supplies and reset positions before the next stage.',
    'guide.basic.armorTitle': 'Front armor',
    'guide.basic.armorBody': 'Player tanks are tougher from the front. Face incoming shells when you must take a hit; flank Bosses when possible.',
    'guide.basic.rankedTitle': 'Ranked vs custom',
    'guide.basic.rankedBody': 'Ranked uses fixed rules and submits scores. Custom is for local multiplayer, gamepads, touch controls, and practice settings.',
    'guide.section.players': 'Player Tanks',
    'guide.player.standardTitle': 'Standard',
    'guide.player.standardBody': 'Balanced attack and defense. From Lv.3 onward it periodically fires armor-piercing shells. Good for ranked and steady pushes.',
    'guide.player.standardTip': 'Tip: angle with your front armor and avoid long frontal trades with Bosses.',
    'guide.player.assaultTitle': 'Assault',
    'guide.player.assaultBody': 'Faster movement and firing tempo. From Lv.3 onward it gains rapid tracer shells that suppress enemy movement.',
    'guide.player.assaultTip': 'Tip: strafe, flank, and do not park inside enemy firing lanes.',
    'guide.player.heavyTitle': 'Heavy',
    'guide.player.heavyBody': 'More HP and armor, slower movement. From Lv.3 onward it gains explosive shells that splash light targets and walls.',
    'guide.player.heavyTip': 'Tip: hold corridors, break cover, and guard the base while avoiding flanks.',
    'guide.section.enemies': 'Enemy Units',
    'guide.enemy.scoutTitle': 'Scout Tank',
    'guide.enemy.scoutBody': 'Red light unit. Fast and fragile, with close-range opportunistic fire.',
    'guide.enemy.scoutTip': 'Tip: clear scouts that slip behind you before they reach the base.',
    'guide.enemy.assaultTitle': 'Assault Tank',
    'guide.enemy.assaultBody': 'Yellow unit with stronger pressure and faster shells than scouts.',
    'guide.enemy.assaultTip': 'Tip: avoid open-field trades; bait it into walls and punish the pause.',
    'guide.enemy.heavyTitle': 'Black Heavy Tank',
    'guide.enemy.heavyBody': 'Slow, durable, and armed with heavier but slower shells.',
    'guide.enemy.heavyTip': 'Tip: keep distance, dodge its shot, then counterfire.',
    'guide.enemy.sniperTitle': 'Sniper Tank',
    'guide.enemy.sniperBody': 'Fragile but eager to aim. Fast shells and long-lane shots make it dangerous.',
    'guide.enemy.sniperTip': 'Tip: do not chase down the same lane; sidestep out of its firing line, then close in.',
    'guide.section.bosses': 'Boss Traits',
    'guide.boss.siegeTitle': 'Siege',
    'guide.boss.siegeBody': 'Baseline Boss with thick front armor and steady positional pressure.',
    'guide.boss.hunterTitle': 'Hunter',
    'guide.boss.hunterBody': 'More mobile with stronger frontal fire, but less front protection than the Bulwark.',
    'guide.boss.bulwarkTitle': 'Bulwark',
    'guide.boss.bulwarkBody': 'The toughest, slowest Boss with the heaviest shells. Frontal trades are expensive.',
    'guide.boss.sniperTitle': 'Sniper',
    'guide.boss.sniperBody': 'Thin armor, high movement, range control, and sudden reverse shots.',
    'guide.section.tactics': 'Battle Tips',
    'guide.tip.one': 'Guard the base entrance first, then push outward so enemies do not slip through the sides.',
    'guide.tip.two': 'Brick walls take multiple hits; steel walls need armor-piercing or special shells.',
    'guide.tip.three': 'Shields prevent damage but still block enemy shells, so you can cover a teammate.',
    'guide.tip.four': 'Do not greed during Boss fights. Wait for a turn, shot, or wall bump, then hit the side or rear.',
    'menu.levelDelay': 'Stage Break',
    'menu.levelDelayHint': 'Pickup window after the field is cleared',
    'menu.seconds.2': '2 sec',
    'menu.seconds.3': '3 sec',
    'menu.seconds.4': '4 sec',
    'menu.seconds.5': '5 sec',
    'menu.seconds.6': '6 sec',
    'menu.seconds.7': '7 sec',
    'menu.seconds.8': '8 sec',
    'menu.seconds.9': '9 sec',
    'menu.seconds.10': '10 sec',
    'menu.obstacleDensity': 'Obstacle Density',
    'menu.obstacleDensityHint': 'Control brick, steel, and terrain blockers',
    'menu.obstacleDensity.low': 'Low',
    'menu.obstacleDensity.normal': 'Normal',
    'menu.obstacleDensity.high': 'High',
    'menu.obstacleDensity.dense': 'Dense',
    'menu.enemyAi': 'Enemy AI',
    'menu.enemyAiHint': 'Classic retro behavior remains the default',
    'menu.enemyAi.classic': 'Classic',
    'menu.enemyAi.enhanced': 'Enhanced',
    'menu.p1Control': 'P1 Controls',
    'menu.p2Control': 'P2 Controls',
    'menu.p3Control': 'P3 Controls',
    'menu.p4Control': 'P4 Controls',
    'menu.controlHint': 'Keyboard, gamepad, or touch controls',
    'menu.controlHintKeyboard': 'Use movement keys and a keyboard fire bind',
    'menu.controlHintGamepad': 'Multi-gamepad support; auto assigns P1-P4 in order',
    'menu.controlHintTouch': 'Use the touch movement area and on-screen fire button',
    'menu.controlHintInactive': 'This player is inactive, so input is disabled',
    'menu.localMultiplayerNote': 'P1-P4 can choose keyboard or gamepad; duplicate keyboard layouts and conflicting fire keys are separated automatically.',
    'menu.control.keyboard': 'Keyboard',
    'menu.control.gamepad': 'Gamepad',
    'menu.control.touchDpad': 'Touch D-pad',
    'menu.control.touchStick': 'Touch Stick',
    'menu.keyboardMove': 'Keyboard Move',
    'menu.keyboardMoveHint': 'Choose the keyboard movement scheme for this player',
    'menu.keyboardMoveHintArrows': 'Currently using the arrow keys',
    'menu.keyboardMoveHintWasd': 'Currently using WASD',
    'menu.keyboardMoveHintTfgh': 'Currently using TFGH',
    'menu.keyboardMoveHintIjkl': 'Currently using IJKL',
    'menu.keyboardMoveHintNumpad': 'Currently using the numpad',
    'menu.keyboardMoveHintInactive': 'This player is inactive, so keyboard movement is unavailable',
    'menu.moveScheme.arrows': 'Arrow Keys',
    'menu.moveScheme.wasd': 'WASD',
    'menu.moveScheme.tfgh': 'TFGH',
    'menu.moveScheme.ijkl': 'IJKL',
    'menu.moveScheme.numpad': 'Numpad',
    'menu.gamepadSlot': 'Gamepad',
    'menu.gamepadSlotHint': 'Choose which gamepad this player uses',
    'menu.playerInactive': 'Inactive',
    'menu.p1Fire': 'P1 Fire',
    'menu.p2Fire': 'P2 Fire',
    'menu.p3Fire': 'P3 Fire',
    'menu.p4Fire': 'P4 Fire',
    'menu.fireBindHint': 'Click and press a key in keyboard mode',
    'menu.fireBindHintGamepad': 'Gamepad mode uses A / RT for fire',
    'menu.fireBindHintTouch': 'Touch mode uses the on-screen fire button',
    'menu.fireBindHintInactive': 'This player is inactive, so fire binding is unavailable',
    'menu.infiniteLives': 'Infinite Lives',
    'menu.infiniteLivesHint': 'Respawn forever after defeat',
    'menu.invincibleBase': 'Invincible Base',
    'menu.invincibleBaseHint': 'Permanent base shield',
    'menu.friendlyFire': 'Friendly Fire',
    'menu.friendlyFireHint': 'Makes co-op a little tenser',
    'menu.upgradeRate': 'Upgrade Drops',
    'menu.upgradeRateHint': 'Controls how often tank upgrade items appear',
    'menu.upgradeRate.off': 'Off',
    'menu.upgradeRate.low': 'Low',
    'menu.upgradeRate.normal': 'Normal',
    'menu.upgradeRate.high': 'High',
    'menu.loseUpgrade': 'Lose Level on Death',
    'menu.loseUpgradeHint': 'Drop one upgrade level after dying',
    'menu.initialLevel': 'Starting Level',
    'menu.initialLevelHint': 'Your tank level on a new run or continue',
    'action.start': 'Start Battle',
    'action.redeploy': 'Redeploy',
    'action.resume': 'Resume',
    'action.restart': 'Restart',
    'action.apply': 'Apply Settings',
    'action.menu': 'Main Menu',
    'action.continue': 'Continue',
    'action.abandon': 'Give Up',
    'action.fullscreen': 'Fullscreen',
    'action.exitFullscreen': 'Exit fullscreen',
    'action.audio': 'Audio',
    'action.previewExplosion': 'Preview explosion audio',
    'action.previewExplosionText': 'FX',
    'control.fireVerb': 'fire',
    'control.system': 'System',
    'control.systemHelp': 'Esc pause · R restart',
    'control.source.keyboardArrows': 'Arrow keys move',
    'control.source.keyboardWasd': 'WASD move',
    'control.source.keyboardTfgh': 'TFGH move',
    'control.source.keyboardIjkl': 'IJKL move',
    'control.source.keyboardNumpad': 'Numpad move',
    'control.source.gamepad': 'Gamepad move',
    'control.gamepad.auto': 'Auto gamepad',
    'control.gamepad.autoOne': 'Auto: Gamepad 1',
    'control.gamepad.autoTwo': 'Auto: Gamepad 2',
    'control.gamepad.autoThree': 'Auto: Gamepad 3',
    'control.gamepad.autoFour': 'Auto: Gamepad 4',
    'control.gamepad.one': 'Gamepad 1',
    'control.gamepad.two': 'Gamepad 2',
    'control.gamepad.three': 'Gamepad 3',
    'control.gamepad.four': 'Gamepad 4',
    'control.source.touchDpad': 'Touch D-pad',
    'control.source.touchStick': 'Touch Stick',
    'control.fire.touch': 'button',
    'control.keyPrompt': 'Press key...',
    'control.key.space': 'Space',
    'ranked.preset': 'Ranked Preset',
    'ranked.presetHint': 'Fixed rules with separate leaderboard boards',
    'ranked.preset.standardSolo': 'Standard Solo',
    'ranked.preset.standardDuo': 'Standard Duo',
    'ranked.preset.hardcoreSolo': 'Hardcore Solo',
    'ranked.preset.hardcoreDuo': 'Hardcore Duo',
    'ranked.variant.standardHint': 'Classic fixed rules for steady score pushing.',
    'ranked.variant.hardcoreHint': 'A tighter, harsher, more dangerous ranked ruleset.',
    'ranked.summary.title': 'Current Ranked Preset',
    'ranked.summary.note': 'Using continues or the developer menu disqualifies this run from the leaderboard.',
    'ranked.summary.board': 'Board',
    'ranked.summary.players': 'Players',
    'ranked.summary.rules': 'Lives & Base',
    'ranked.summary.progression': 'Progression & FF',
    'ranked.summary.battlefield': 'Field & AI',
    'ranked.summary.rulesValue': 'Limited lives · Vulnerable base',
    'ranked.summary.progression.standard': 'Normal drops · No level loss · Friendly fire off',
    'ranked.summary.progression.hardcore': 'Low drops · Lose level on death · Friendly fire on',
    'ranked.summary.battlefield.standard': '5 sec break · High obstacles · Classic AI',
    'ranked.summary.battlefield.hardcore': '5 sec break · Dense obstacles · Enhanced AI',
    'ranked.summary.ranked': 'Leaderboard',
    'leaderboard.title': 'Ranked Leaderboard',
    'leaderboard.kicker': 'Ranked Board',
    'leaderboard.close': 'Close leaderboard',
    'leaderboard.open': 'Leaderboard',
    'leaderboard.editProfile': 'Edit Name',
    'leaderboard.identityLabel': 'Ranked identity',
    'leaderboard.identityKicker': 'Ranked Identity',
    'leaderboard.profileTitle': 'Player Profile',
    'leaderboard.profileHint': 'Confirm your name and target board before starting ranked.',
    'leaderboard.refresh': 'Refresh',
    'leaderboard.nickname': 'Leaderboard Name',
    'leaderboard.nicknameHint': 'Used when submitting a ranked-mode score',
    'leaderboard.tabs': 'Leaderboard Modes',
    'leaderboard.tabStandardSolo': 'Standard Solo',
    'leaderboard.tabStandardDuo': 'Standard Duo',
    'leaderboard.tabHardcoreSolo': 'Hardcore Solo',
    'leaderboard.tabHardcoreDuo': 'Hardcore Duo',
    'leaderboard.loading': 'Loading leaderboard…',
    'leaderboard.empty': 'No ranked runs yet. Be the first one up there.',
    'leaderboard.unavailable': 'Leaderboard is unavailable until the backend database is connected.',
    'leaderboard.note': 'Only ranked-mode runs can be uploaded. Standard/hardcore and solo/duo are all tracked separately.',
    'leaderboard.rank': 'Rank #{rank}',
    'leaderboard.scoreLine': 'Score {score} · Stage {stage}',
    'leaderboard.durationLine': 'Time {minutes}:{seconds}',
    'leaderboard.statusTitle': 'Latest Ranked Result',
    'leaderboard.statusRanked': '{mode} · {score} pts · Rank #{rank}',
    'leaderboard.statusBest': 'Current personal best {bestScore} pts · Stage {bestStage}',
    'leaderboard.statusBestImproved': 'New personal best. Keep it going.',
    'leaderboard.celebrationKicker': 'Ranked Breakthrough',
    'leaderboard.celebrationSummary': '{mode} · {score} pts · Rank #{rank}',
    'leaderboard.statusMilestone.top10': 'First Top 10',
    'leaderboard.statusMilestone.top3': 'First Top 3',
    'leaderboard.statusMilestone.champion': 'First #1 Finish',
    'leaderboard.statusMilestone.personalBest': 'Personal Best',
    'leaderboard.meTitle': 'My Standing',
    'leaderboard.meEmpty': 'You do not have a score on this board yet. Go post one.',
    'leaderboard.meRanked': '{nickname} · Rank #{rank} · {score} pts',
    'leaderboard.meBest': 'Best stage {stage} · Time {minutes}:{seconds}',
    'leaderboard.meBadge': 'You',
    'leaderboard.identityBoardActive': 'Current ranked: {mode}',
    'leaderboard.identityBoardCustom': 'Viewing board: {mode}',
    'leaderboard.identityLoadingTitle': 'Loading current rank',
    'leaderboard.identityLoadingDetail': 'Connecting to the leaderboard.',
    'leaderboard.identityUnavailableTitle': 'Leaderboard unavailable',
    'leaderboard.identityUnavailableDetail': 'You can still play locally and refresh later.',
    'leaderboard.identityEmptyTitle': 'No score on this board yet',
    'leaderboard.identityEmptyDetail': 'Set a name, choose ranked, and post the first run.',
    'leaderboard.identityRankedTitle': 'Rank #{rank} · {score} pts',
    'leaderboard.identityRankedDetail': '{mode} · Stage {stage} · Time {minutes}:{seconds}',
    'leaderboard.practiceMode': 'Your ranked score is now locked. Continuing turns this run into practice only.',
    'leaderboard.eligibilityUnknown': 'Current setup has not been checked yet',
    'leaderboard.eligiblePreset': 'Current setup submits to {mode}',
    'leaderboard.ineligible': 'Current setup is a custom mode and does not submit to the leaderboard',
    'leaderboard.submitSuccess': 'Leaderboard submitted · {mode}',
    'leaderboard.submitSuccessDetailed': '{mode} recorded · {score} pts · Rank #{rank}',
    'leaderboard.submitSkipped': 'This run did not qualify for the leaderboard',
    'leaderboard.submitFailed': 'Leaderboard submission failed. Try again later.',
    'touch.controls': 'Touch controls',
    'touch.stick': 'Movement stick',
    'touch.dpad': 'Movement D-pad',
    'touch.mode': 'Touch mode',
    'touch.mode.stick': 'Stick',
    'touch.lockLayout': 'Lock layout',
    'touch.unlockLayout': 'Unlock layout',
    'touch.fire': 'Fire',
    'touch.pause': 'Pause',
    'touch.rotate': 'Rotate to landscape',
    'touch.up': 'Up',
    'touch.down': 'Down',
    'touch.left': 'Left',
    'touch.right': 'Right',
    'confirm.restartLevel': 'Restart this stage? Current stage progress will be lost.',
    'confirm.applySettings': 'Apply settings and redeploy? Current battle progress will be lost.',
    'confirm.returnMenu': 'Return to the main menu? Current battle progress will be lost.',
    'confirm.abandonContinue': 'Give up this continue and return to the main menu? The current run will end.',
    'overlay.pause.title': 'Paused',
    'overlay.pause.subtitle': 'Resume, restart, or adjust the setup before redeploying.',
    'overlay.continue.title': 'Continue battle?',
    'overlay.continue.subtitle': '{reason}. {count} continues left. Continuing restores full lives, resets tank upgrades, and resumes the current stage.',
    'overlay.continue.rankedRecorded': '{reason}. {count} continues left. Your current score of {score} has been recorded to {mode} at rank #{rank}. If you continue, the rest of this run becomes practice and will no longer update this ranked result.',
    'overlay.gameOver.title': 'Mission Failed',
    'overlay.gameOver.subtitle': '{reason}. No continues remaining.',
    'status.paused': 'Paused',
    'status.nextLevel': 'Next {seconds}',
    'settlement.kicker': 'Area Secured',
    'settlement.title': 'Stage {level} Clear',
    'settlement.bonus': 'Clear bonus +{bonus}',
    'settlement.collect': 'Collect supplies before redeploy',
    'settlement.next': 'Stage {level} in {seconds}s',
    'message.paused': 'Paused',
    'message.resume': 'Back in action',
    'message.level': 'Stage {level}',
    'message.baseDamaged': 'Base hit {hp}/3',
    'message.respawn': 'P{player} respawned',
    'message.bossIncoming': '{variant} Boss incoming',
    'message.continue': 'Continue used · {count} left',
    'message.levelComplete': 'Stage clear',
    'enemy.short.light': 'Scout',
    'enemy.short.assault': 'Asslt',
    'enemy.short.heavy': 'Heavy',
    'enemy.short.sniper': 'Snipr',
    'enemy.short.boss': 'Boss',
    'bossVariant.siege': 'Siege',
    'bossVariant.hunter': 'Hunter',
    'bossVariant.bulwark': 'Bulwark',
    'bossVariant.sniper': 'Sniper',
    'bossVariant.preview.siege': 'Siege',
    'bossVariant.preview.hunter': 'Hunter',
    'bossVariant.preview.bulwark': 'Bulwark',
    'bossVariant.preview.sniper': 'Sniper',
    'dev.title': 'Developer menu',
    'dev.section': 'Developer menu',
    'dev.level': 'Jump to stage',
    'dev.levelHint': 'Start any stage directly while keeping the current rule set',
    'dev.jump': 'Jump',
    'dev.powerup': 'Spawn powerup',
    'dev.powerupHint': 'Create a test pickup near the player tank',
    'dev.enemy': 'Spawn enemy',
    'dev.enemyHint': 'Create a chosen enemy for HP and behavior testing',
    'dev.bossVariant': 'Boss type',
    'dev.bossVariantHint': 'Choose which Boss variant to spawn manually',
    'dev.speed': 'Slow motion',
    'dev.speedHint': 'Lower the overall time scale to inspect windups and collisions',
    'dev.aiOverlay': 'AI debug overlay',
    'dev.aiOverlayHint': 'Show current target, state, and movement direction above enemies',
    'dev.playerInvincible': 'Temporary player invincibility',
    'dev.playerInvincibleHint': 'Testing only and separate from the normal rule setup',
    'dev.baseInvincible': 'Temporary base invincibility',
    'dev.baseInvincibleHint': 'Useful for repeated Boss, spawn, and base alert tests',
    'dev.audioState': 'Audio state',
    'dev.audioStateHint': 'Helps diagnose when iPhone / iPad browsers suspend game audio',
    'dev.audioWake': 'Wake audio',
    'dev.audio.running': 'Running',
    'dev.audio.suspended': 'Suspended',
    'dev.audio.interrupted': 'Interrupted',
    'dev.audio.closed': 'Closed',
    'dev.audio.unavailable': 'Not created',
    'dev.spawn': 'Spawn',
    'dev.collapse': 'Collapse',
    'dev.expand': 'Expand',
    'dev.spawnEnemy': 'Spawn',
    'dev.step': 'Advance 1 frame',
    'dev.healPlayers': 'Refill HP',
    'dev.maxUpgrade': 'Set Lv.4',
    'dev.clearEnemies': 'Clear enemies',
    'dev.spawnBoss': 'Spawn Boss',
    'dev.damageBase': 'Damage base state',
    'dev.hint': 'Testing only. Press F12 again to hide it; if the browser intercepts F12, try Shift + `.',
    'dev.toast.jump': 'Debug jump · Stage {level}',
    'dev.toast.healed': 'Debug refill · Team healed',
    'dev.toast.upgrade': 'Debug upgrade · Team set to Lv.{level}',
    'dev.toast.powerup': 'Debug spawn · {powerup}',
    'dev.toast.speed': 'Debug time scale · {scale}×',
    'dev.toast.clear': 'Debug clear · Removed {count} enemies',
    'dev.toast.playerInvincibleOn': 'Debug toggle · Player invincibility enabled',
    'dev.toast.playerInvincibleOff': 'Debug toggle · Player invincibility disabled',
    'dev.toast.baseInvincibleOn': 'Debug toggle · Base invincibility enabled',
    'dev.toast.baseInvincibleOff': 'Debug toggle · Base invincibility disabled',
    'dev.toast.baseDamaged': 'Debug state · Base set to damaged',
    'dev.toast.spawnEnemy': 'Debug spawn · {enemy}',
    'dev.toast.spawnBlocked': 'Debug spawn failed · Spawn point is blocked',
    'dev.enemy.boss': 'Boss',
    'dev.enemy.heavy': 'Heavy Tank',
    'dev.enemy.sniper': 'Sniper Tank',
    'dev.enemy.assault': 'Assault Tank',
    'dev.enemy.light': 'Light Tank',
    'powerup.rapid': 'Rapid Fire',
    'powerup.shield': 'Shield Up',
    'powerup.bomb': 'Air Strike',
    'powerup.life': 'Extra Life',
    'powerup.freeze': 'Freeze Enemies',
    'powerup.repair': 'Repair Base',
    'powerup.baseShield': 'Base Shield',
    'powerup.jam': 'EMP Jam',
    'powerup.upgrade': 'Tank Upgrade',
    'powerup.heal': 'Full Repair',
    'message.powerupPickup': '{powerup} P{player}',
    'gameOver.baseDestroyed': 'The base was destroyed',
    'gameOver.outOfLives': 'Out of lives',
    'base.invincible': 'Invincible',
    'base.shielded': 'Shielded',
    'base.destroyed': 'Destroyed',
    'base.stable': 'Stable',
  },
};

let currentLocale: Locale = 'zh';

export function getLocale(): Locale {
  return currentLocale;
}

export function setLocale(locale: Locale): void {
  currentLocale = locale;
}

export function t(key: string, params?: Params): string {
  const template = translations[currentLocale][key] ?? translations.zh[key] ?? key;
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (_, name: string) => String(params[name] ?? `{${name}}`));
}

export function translateDocument(root: ParentNode = document): void {
  for (const element of root.querySelectorAll<HTMLElement>('[data-i18n]')) {
    const key = element.dataset.i18n;
    if (!key) continue;
    element.textContent = t(key);
  }
  for (const element of root.querySelectorAll<HTMLElement>('[data-i18n-title]')) {
    const key = element.dataset.i18nTitle;
    if (!key) continue;
    element.setAttribute('title', t(key));
  }
  for (const element of root.querySelectorAll<HTMLElement>('[data-i18n-aria-label]')) {
    const key = element.dataset.i18nAriaLabel;
    if (!key) continue;
    element.setAttribute('aria-label', t(key));
  }
}
